import { render, staticRenderFns } from "./ExtrafeeSummary.vue?vue&type=template&id=6a6d02e7&"
import script from "./ExtrafeeSummary.vue?vue&type=script&lang=js&"
export * from "./ExtrafeeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports